import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import PageLayout from '../components/PageLayout';

const PrivacyPolicy = () => {
  const { t } = useLanguage();
  const location = useLocation();

  // Set document title
  useEffect(() => {
    document.title = `${t('privacy.title')} - ${t('app.title')}`;
  }, [t, location]);

  return (
    <PageLayout 
      title={t('privacy.title')}
      subtitle={t('privacy.subtitle')}
    >
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-6 sm:p-8 lg:p-10 border border-gray-200 dark:border-gray-600">
            <div className="prose prose-lg dark:prose-invert max-w-none">
              <div className="mb-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
                <p className="text-blue-800 dark:text-blue-200 font-semibold mb-2">
                  {t('privacy.effectiveDate')}
                </p>
                <p className="text-blue-700 dark:text-blue-300 text-sm">
                  {t('privacy.welcome')}
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
                {t('privacy.dataCollection.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-3">
                {t('privacy.dataCollection.noPersonalData.title')}
              </h3>
              <p className="text-gray-600 dark:text-gray-300 mb-4">
                {t('privacy.dataCollection.noPersonalData.content')}
              </p>
              <ul className="list-disc list-inside text-gray-600 dark:text-gray-300 mb-6 space-y-2">
                <li>{t('privacy.dataCollection.noPersonalData.item1')}</li>
                <li>{t('privacy.dataCollection.noPersonalData.item2')}</li>
                <li>{t('privacy.dataCollection.noPersonalData.item3')}</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-3">
                {t('privacy.dataCollection.logData.title')}
              </h3>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                {t('privacy.dataCollection.logData.content')}
              </p>

              <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
                {t('privacy.thirdPartyServices.title')}
              </h2>
              <p className="text-gray-600 dark:text-gray-300 mb-4">
                {t('privacy.thirdPartyServices.content')}
              </p>
              <p className="text-gray-600 dark:text-gray-300 mb-4 font-semibold">
                {t('privacy.thirdPartyServices.googleAdSense')}
              </p>
              <ul className="list-disc list-inside text-gray-600 dark:text-gray-300 mb-6 space-y-2">
                <li>{t('privacy.thirdPartyServices.item1')}</li>
                <li>{t('privacy.thirdPartyServices.item2')}</li>
                <li>{t('privacy.thirdPartyServices.item3')}</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
                {t('privacy.links.title')}
              </h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                {t('privacy.links.content')}
              </p>

              <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
                {t('privacy.changes.title')}
              </h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                {t('privacy.changes.content')}
              </p>

              <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
                {t('privacy.contact.title')}
              </h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                {t('privacy.contact.content')}
              </p>
            </div>
          </div>
    </PageLayout>
  );
};

export default PrivacyPolicy;
